// extracted by mini-css-extract-plugin
export default {"copy-history":"CopyHistoryPanel_copy-history__P1cMM"};